/**
 * Type: コンポーネント
 * What: ヘッダー
 */
import React, { useState, useEffect } from 'react';
import { Link, StaticQuery, graphql } from 'gatsby';
import { scroller } from 'react-scroll';
import Image from '../util/Image';
import {
  HEADER_LINKS,
  WATCH_LINKS,
  HBG_LINK,
  PLAY_LINKS,
  EAT_LINKS,
  EVENT_LINKS,
} from '../config/Links';
import '../sass/components/_header.scss';
import { Button } from './Btn';
import AccordionMin from './Accordion-min';

export const List = (props) => (
  <>
    {props.target ? (
      <a
        href={props.link}
        className={props.bold ? 'fwb' : ''}
        target="_blank"
        rel="noopener noreferrer"
      >
        {props.pageName}
        <Image src="breadcrumb-arrow.svg" />
      </a>
    ) : (
      <Link
        to={props.link}
        className={`${props.bold ? 'fwb' : ''} ${!props.link ? 'disable' : ''}`}
      >
        {props.pageName}
        {props.link ? <Image src="breadcrumb-arrow.svg" /> : null}
      </Link>
    )}
  </>
);

// 現在のページがTOPか確認
const topPageCheck = () => {
  if (typeof window !== 'undefined') {
    const { location } = window;
    if (location.pathname === '/') {
      return true;
    }
    return false;
  }
  return false;
};

// const ankerLinkScroll = (e, elem, offset) => {
//   e.preventDefault();
//   let $offset = offset || -160;
//   if (window.matchMedia('screen and (max-width: 768px)').matches) {
//     $offset = offset || -110;
//   }
//   scroller.scrollTo(elem, {
//     duration: 1200,
//     delay: 0,
//     offset: $offset,
//     smooth: 'easeOutQuint',
//   });
// };

const Header = (props) => {
  const [lang, setLang] = useState('');
  const changelang = (e) => {
    setLang(e.currentTarget.dataset.value);
  };

  const langView = (val) => {
    if (val === 'ja') {
      return 'JP';
    }
    if (val === 'en') {
      return 'English';
    }
    if (val === 'ko') {
      return '한국어';
    }
    if (val === 'zh-CHS') {
      return '简体中文';
    }
    if (val === 'zh-CHT') {
      return '繁體中文';
    }
    return false;
  };

  const scrollToTarget = (e, elem, offset) => {
    e.preventDefault();
    let $offset = offset || -160;
    if (window.matchMedia('screen and (max-width: 768px)').matches) {
      $offset = offset || -110;
      props.setHbgOpen(false);
    }
    scroller.scrollTo(elem, {
      duration: 1200,
      delay: 0,
      offset: $offset,
      smooth: 'easeOutQuint',
    });
  };

  const changelangSp = (e) => {
    setLang(e.currentTarget.value);
    /* eslint no-undef: 0 */
    if (typeof WOVN !== 'undefined') {
      WOVN.io.changeLang(e.currentTarget.value);
    }
  };

  useEffect(() => {
    setLang(props.lang);
  }, [props.lang]);

  // spドロップダウンのタブ表示中
  const [isDropDownTab, setDropDownTab] = useState('');

  // spドロップダウンタブクリックイベント
  const onClickDropDown = (tabKey) => {
    setDropDownTab((prev) => (prev === tabKey ? '' : tabKey));
  };

  return (
    <StaticQuery
      query={graphql`
        query {
          site {
            siteMetadata {
              title
              ticketReady
              eventHall
              routingSlug {
                posts
              }
            }
          }
        }
      `}
      render={(data) => {
        const SITE_TITLE = data.site.siteMetadata.title;
        // const READY = data.site.siteMetadata.ticketReady;
        // const POST_URL = data.site.siteMetadata.routingSlug.posts;
        const eventHallShow = data.site.siteMetadata.eventHall;
        return (
          <>
            <header className={props.hbgOpen ? 'header open' : 'header'}>
              <div
                className={`header-inner ${props.scroll ? '' : 'displayLine'}`}
              >
                <h1 className="header-ttl">
                  <Link to="/">
                    <span className="header-ttl-sub">
                      みずほPayPayドーム目の前のエンタメ施設
                    </span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 138.13 24.68"
                    >
                      <title>{SITE_TITLE}</title>
                      <g>
                        <path
                          className="cls-1"
                          d="M30.58,7.87H28a.31.31,0,0,0-.25.5l2.65,3.35a.32.32,0,0,1,0,.39l-2.64,3.34A.31.31,0,0,0,28,16h2.63a.32.32,0,0,0,.24-.11l2.94-3.73a.32.32,0,0,0,0-.39L30.82,8a.3.3,0,0,0-.24-.11"
                        />
                        <path
                          className="cls-1"
                          d="M25.34,7.87H22.71a.31.31,0,0,0-.25.5l2.65,3.35a.32.32,0,0,1,0,.39l-2.64,3.34a.31.31,0,0,0,.25.5h2.63a.32.32,0,0,0,.24-.11l2.94-3.73a.32.32,0,0,0,0-.39L25.58,8a.3.3,0,0,0-.24-.11"
                        />
                        <path
                          className="cls-1"
                          d="M20.1,7.87H17.47a.31.31,0,0,0-.25.5l2.65,3.35a.32.32,0,0,1,0,.39l-2.64,3.34a.31.31,0,0,0,.25.5h2.63a.32.32,0,0,0,.24-.11l2.94-3.73a.32.32,0,0,0,0-.39L20.34,8a.29.29,0,0,0-.24-.11"
                        />
                        <path
                          className="cls-2"
                          d="M.52,23.83H15a.52.52,0,0,0,.52-.52V20.09a.52.52,0,0,0-.52-.52H4.65a.25.25,0,0,1-.25-.26V14.12a.25.25,0,0,1,.25-.26h9a.52.52,0,0,0,.52-.52v-3a.51.51,0,0,0-.52-.51H4.69a.26.26,0,0,1-.26-.26v-5a.26.26,0,0,1,.26-.26H15a.52.52,0,0,0,.52-.52V.72A.53.53,0,0,0,15,.2H.52A.52.52,0,0,0,0,.72V23.31a.52.52,0,0,0,.52.52"
                        />
                        <path
                          className="cls-2"
                          d="M35,4.16h8.73a.15.15,0,0,1,.13.23L34.2,20.2a.5.5,0,0,0-.07.27v2.84a.51.51,0,0,0,.51.52H49.1a.52.52,0,0,0,.52-.52V20.16a.52.52,0,0,0-.52-.52H39.93a.16.16,0,0,1-.14-.24L49.54,3.56a.5.5,0,0,0,.08-.27V.72A.52.52,0,0,0,49.1.2H35a.52.52,0,0,0-.52.52V3.64a.52.52,0,0,0,.52.52"
                        />
                        <path
                          className="cls-2"
                          d="M60.6,0A8.6,8.6,0,0,0,52,8.61v6.57A8.49,8.49,0,0,0,60.56,24c4.59,0,8.62-3.86,8.62-8.27V8.61A8.5,8.5,0,0,0,60.6,0M56.45,8.61A4.1,4.1,0,0,1,60.63,4.4a4.16,4.16,0,0,1,3.57,2A3.91,3.91,0,0,1,64.78,8v7.16a4.25,4.25,0,0,1-4.22,4.46,4.17,4.17,0,0,1-4.11-4.22Z"
                        />
                        <path
                          className="cls-2"
                          d="M78.27,1.76V4.35a.21.21,0,0,0,.21.22h3.69a.21.21,0,0,1,.22.21V5.7a.22.22,0,0,1-.22.22H78.48a.21.21,0,0,0-.21.22V9.9a.21.21,0,0,1-.22.21H77a.21.21,0,0,1-.22-.21V.41A.22.22,0,0,1,77,.19h5.91a.21.21,0,0,1,.21.22v.91a.21.21,0,0,1-.21.22H78.48a.21.21,0,0,0-.21.22"
                        />
                        <path
                          className="cls-2"
                          d="M88.26,10.2a3.36,3.36,0,0,1-3.55-3.43V.39a.19.19,0,0,1,.19-.2H86a.2.2,0,0,1,.2.2V6.7a2.06,2.06,0,1,0,4.11,0V.39a.2.2,0,0,1,.2-.2h1.11a.2.2,0,0,1,.2.2V6.77a3.38,3.38,0,0,1-3.57,3.43"
                        />
                        <path
                          className="cls-2"
                          d="M100.27,10,97.59,5.3a.07.07,0,0,0-.11,0L95.9,7.2a.09.09,0,0,0,0,.07V9.9a.21.21,0,0,1-.22.21H94.58a.21.21,0,0,1-.22-.21V.41a.22.22,0,0,1,.22-.22h1.07a.22.22,0,0,1,.22.22V5A.06.06,0,0,0,96,5L99.86.27A.21.21,0,0,1,100,.19h1.27a.22.22,0,0,1,.17.36L98.57,4a.08.08,0,0,0,0,.08l3.34,5.67a.21.21,0,0,1-.19.32h-1.26a.21.21,0,0,1-.19-.11"
                        />
                        <path
                          className="cls-2"
                          d="M127.49,10l-2.68-4.7a.07.07,0,0,0-.11,0L123.12,7.2a.09.09,0,0,0,0,.07V9.9a.21.21,0,0,1-.22.21H121.8a.21.21,0,0,1-.22-.21V.41a.22.22,0,0,1,.22-.22h1.07a.22.22,0,0,1,.22.22V5a.06.06,0,0,0,.11,0L127.08.27a.21.21,0,0,1,.17-.08h1.27a.22.22,0,0,1,.17.36L125.79,4a.08.08,0,0,0,0,.08l3.34,5.67a.21.21,0,0,1-.19.32h-1.27a.2.2,0,0,1-.18-.11"
                        />
                        <path
                          className="cls-2"
                          d="M106.91,10.2a3.36,3.36,0,0,1-3.55-3.43V.39a.19.19,0,0,1,.19-.2h1.11a.2.2,0,0,1,.2.2V6.7a2.06,2.06,0,1,0,4.11,0V.39a.2.2,0,0,1,.2-.2h1.11a.2.2,0,0,1,.2.2V6.77a3.38,3.38,0,0,1-3.57,3.43"
                        />
                        <path
                          className="cls-2"
                          d="M118.59,9.14A3.6,3.6,0,0,1,116,10.2a3.56,3.56,0,0,1-2.61-1.06c-1-1-1-2.08-1-4s0-3,1-4A3.53,3.53,0,0,1,116,.11a3.57,3.57,0,0,1,2.62,1.06c1,1,.94,2.07.94,4s0,3-.94,4m-1.15-7.07A2,2,0,0,0,116,1.46a2,2,0,0,0-1.48.61c-.49.53-.59,1.09-.59,3.08s.1,2.55.59,3.08a2,2,0,0,0,1.48.62,2,2,0,0,0,1.47-.62c.49-.53.59-1.08.59-3.08s-.1-2.55-.59-3.08"
                        />
                        <path
                          className="cls-2"
                          d="M136.57,10,136,8.17a.08.08,0,0,0-.07-.05h-3.82a.06.06,0,0,0-.06.05l-.62,1.8a.21.21,0,0,1-.21.14h-1.13a.22.22,0,0,1-.21-.29L133.32.33a.23.23,0,0,1,.21-.14h.91a.22.22,0,0,1,.2.14l3.48,9.49a.22.22,0,0,1-.21.29h-1.13a.22.22,0,0,1-.21-.14M134,2.61,132.5,6.75a.07.07,0,0,0,.06.09h2.87a.06.06,0,0,0,.06-.09l-1.41-4.14a.07.07,0,0,0-.13,0"
                        />
                        <path
                          className="cls-2"
                          d="M104.33,13.86a3.94,3.94,0,0,1,2.63.67c.27.22.3.82.3,1.11a8.25,8.25,0,0,0,.09.94c.05.34-.58.74-.92-.08a2.14,2.14,0,0,0-2.06-1.59A1.19,1.19,0,0,0,103.15,16c0,.85,1.23,1.31,1.39,1.41s1.16.57,1.72.92a2.64,2.64,0,0,1,1.48,2.54c0,1.76-1.12,3-3.38,2.94-1.54,0-2.57-.34-2.83-.79a9.55,9.55,0,0,1-.38-2c0-.58.64-.63.88-.13a2.92,2.92,0,0,0,2.43,1.86,1.3,1.3,0,0,0,1.45-1.25c0-.77-.6-1-1.68-1.59-1.37-.71-2.92-1.33-2.89-3.33a2.72,2.72,0,0,1,3-2.74"
                        />
                        <path
                          className="cls-2"
                          d="M97.08,13.86a3.89,3.89,0,0,1,2.63.67c.28.22.31.82.31,1.11a8.25,8.25,0,0,0,.09.94c0,.34-.58.74-.92-.08a2.14,2.14,0,0,0-2.06-1.59A1.18,1.18,0,0,0,95.91,16c0,.85,1.23,1.31,1.38,1.41s1.17.57,1.73.92a2.65,2.65,0,0,1,1.48,2.54c0,1.76-1.12,3-3.39,2.94-1.53,0-2.56-.34-2.82-.79a9.57,9.57,0,0,1-.39-2c0-.58.65-.63.89-.13a2.93,2.93,0,0,0,2.42,1.86,1.31,1.31,0,0,0,1.46-1.25c0-.77-.61-1-1.68-1.59-1.38-.71-2.93-1.33-2.89-3.33a2.71,2.71,0,0,1,3-2.74"
                        />
                        <path
                          className="cls-2"
                          d="M76.32,14.09c.44,0,1.34,0,2.24,0S80.29,14,80.77,14a2.29,2.29,0,0,1,2.42,2.17,2.14,2.14,0,0,1-1.33,2.08s-.06.08,0,.1a2.45,2.45,0,0,1,1.93,2.48,2.79,2.79,0,0,1-3,2.9c-.78,0-1.61-.12-2.25-.11-1.12,0-2,0-2.19,0-.46,0-.49-.63-.06-.84.59-.27.63-.47.63-.59,0-.31,0-6,0-6s0-.42-.06-.79-.25-.38-.6-.54a.41.41,0,0,1,0-.79m2.8,3.62c0,.15,0,.17.13.17,1.18.06,1.67-.28,1.69-1.41a1.21,1.21,0,0,0-1.23-1.38.52.52,0,0,0-.59.48c0,.23,0,2,0,2.14m0,1.69v2c0,.95.36,1.05,1,1.15.32.05,1.38-.2,1.36-1.66s-1.14-1.68-2.23-1.59a.13.13,0,0,0-.12.13"
                        />
                        <path
                          className="cls-2"
                          d="M88.89,13.88c2.48,0,4.49,1.89,4.49,4.88,0,3.21-1.92,5-4.49,5s-4.51-1.68-4.51-5c0-2.77,1.62-4.88,4.51-4.88m-2.2,4.83c0,2.33.59,3.95,2.21,3.95S91,20.79,91,18.71,90.27,15,88.9,15s-2.21,1.36-2.21,3.68"
                        />
                        <path
                          className="cls-2"
                          d="M112.07,17.06a3.28,3.28,0,0,1,.5-.42.15.15,0,0,1,.16.1,1.24,1.24,0,0,1,0,.51c-.1.31-.49.47-.52.81a.16.16,0,0,1-.08.08.11.11,0,0,1-.11-.08c0-.25-.08-.5-.11-.75a.39.39,0,0,1,.12-.25m-1.68,4.87c-.33-.12-.8-.26-.86-.68a5.61,5.61,0,0,1,0-1.16.16.16,0,0,1,.11-.16,4.74,4.74,0,0,1,1.26-.2c.08,0,.12.12.17.19.14.27.24.55.36.82.1.11.26.05.37,0s.47-.19.72-.3c0,0,.09-.05.05-.1a1,1,0,0,1-.18-.57c0-.08,0-.19.1-.22s.19-.07.21-.16a.17.17,0,0,0,0-.14c-.16-.18-.64-.13-.51-.49.11-.1.26,0,.38-.07a.42.42,0,0,1,.31-.18,1.94,1.94,0,0,1,.82.23.19.19,0,0,1,0,.16c-.11.15-.32.1-.49.14a.13.13,0,0,0-.07.12.13.13,0,0,0,.1.12,8,8,0,0,1,1.17.38.71.71,0,0,1,.36.66.11.11,0,0,1-.07.09c-.22,0-.36-.2-.59-.12s-.34.08-.51.08l0,.05-2,1.28a1.64,1.64,0,0,1-1.13.21m3.8-5.08c.23-.06.52-.28.76-.06.1.06.25.15.24.29s-.15,0-.22,0c-.4-.11-.72.19-1.12.13-.12,0-.26,0-.36-.11a1.74,1.74,0,0,1-.37-.79s0-.1.07-.12.2.11.32.12a.39.39,0,0,0,.28,0c.41-.09.91-.39,1.31-.08l.2.14s.1.07.08.13-.35,0-.53,0a.59.59,0,0,0-.6.2s-.1.1-.06.15m.13.89a.67.67,0,0,1-.41-.22s0-.08.06-.08c.37-.05.72-.15,1.08-.2l0,0s0,.09,0,.13a1.15,1.15,0,0,1-.74.35m.6,2s0,.1-.08.1-.12-.12-.17-.19a5.56,5.56,0,0,0-.79-1.1.11.11,0,0,1,0-.11c.12,0,.21.08.29.15a2.09,2.09,0,0,1,.75,1.15m4.43,1.64c-.39.4-.75.83-1.14,1.24a1.41,1.41,0,0,1-.66.32,11.15,11.15,0,0,0-1,1.18l-.39.56a.21.21,0,0,1-.19,0c-.12-.07-.17-.21-.27-.31a8.35,8.35,0,0,0-1.11-1.27,1.86,1.86,0,0,0-1.26-.39.83.83,0,0,1-.69-.63.09.09,0,0,1,.08-.11,5.4,5.4,0,0,0,.72.15A1.14,1.14,0,0,0,114,22l1.14-.61a1.94,1.94,0,0,1,.72,0,.59.59,0,0,0,.34-.15l1-1,.33-.35c.06-.06.17,0,.19.08a2.62,2.62,0,0,1-.32.94,7.56,7.56,0,0,0-.49,1.13.34.34,0,0,0,0,.2.1.1,0,0,0,.13,0l0,0,1.12-1.1a.63.63,0,0,1,.34-.22c.2.07.41-.11.59,0a.82.82,0,0,1,.25.2.27.27,0,0,1-.05.23m-3.13-4a0,0,0,0,1,0,0c0,.08-.07.09-.11.12a1,1,0,0,1-.66-.13s0-.07,0-.1l0,0c.22,0,.47.05.7.09M115.6,17c0-.06.07-.07.11-.09l.48-.17a.06.06,0,0,1,.08,0v.06a.68.68,0,0,1-.58.23s-.06,0-.08-.07m3.24,3.17a2.17,2.17,0,0,1-.57.33c-.1,0-.1-.11-.14-.17l-.11-.78a.19.19,0,0,1,.07-.14c.09-.06.19,0,.29,0,.42,0,.71-.39.9-.72a2.91,2.91,0,0,0,.22-1.5.37.37,0,0,0-.15-.22c-.34-.11-.58.21-.8.43a5.59,5.59,0,0,0-.69,1,.24.24,0,0,1-.23.07c-.08,0-.1-.12-.13-.19,0-.31-.11-.61-.14-.94s.36-.7.41-1.11a9,9,0,0,0-.34-1,1.1,1.1,0,0,0-.32-.48,2.78,2.78,0,0,0-1.89-.37c-.79.25-1.55.58-2.32.86a.16.16,0,0,1-.15,0,.08.08,0,0,1,0-.12,5.47,5.47,0,0,1,.83-1.33,3.65,3.65,0,0,1,1.52-.36,6.8,6.8,0,0,1,.92.18,11,11,0,0,0,1.82.08,3.09,3.09,0,0,1,1.2.74,5.39,5.39,0,0,1,1,1.24,7.42,7.42,0,0,1,.25,2.33,2.7,2.7,0,0,1-.19,1.11,6.46,6.46,0,0,1-1.25,1.2m-.17-1.9c0,.18.1.4,0,.55a.67.67,0,0,1-.4.2c-.14-.11,0-.3,0-.45a2.91,2.91,0,0,1,.52-1.06.29.29,0,0,1,.33-.11.26.26,0,0,1,.13.1.22.22,0,0,1,0,.16c-.17.21-.64.23-.53.61"
                        />
                      </g>
                    </svg>
                  </Link>
                </h1>
                {/* <div className="catch"> */}
                {/*  <Image filename="catch.png" alt="7.21 OPEN" /> */}
                {/* </div> */}
                <div className="header-nav-top pc">
                  <ul className="header-nav-top-link">
                    <li>
                      <a href="/inquiry/chat/">お問合わせ</a>
                    </li>
                    <li>
                      <Link to="/schedule/">施設の営業時間</Link>
                    </li>
                  </ul>
                  <ul className="sns">
                    <li className="cn-hide">
                      <a
                        href="https://twitter.com/EZOFUKUOKA"
                        className="tw"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Image
                          src="icon-tw.png"
                          alt="twitter"
                          target="_blank"
                          width="24px"
                          height="24px"
                        />
                      </a>
                    </li>
                    <li className="cn-hide">
                      <a
                        href="https://www.instagram.com/ezofukuoka/"
                        className="ig"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Image
                          src="ig.svg"
                          alt="instagram"
                          target="_blank"
                          width="26px"
                          height="28px"
                        />
                      </a>
                    </li>
                    <li className="cn-hide">
                      <a
                        href="https://www.youtube.com/channel/UCf_4SX2KMdo1ieafAj2vwLw"
                        className="yt"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Image
                          src="icon-youtube.svg"
                          alt="youtube"
                          target="_blank"
                          width="26px"
                          height="26px"
                        />
                      </a>
                    </li>
                  </ul>
                  <div className="header-lang">
                    <div className="header-lang-current">
                      {lang ? (
                        <span wovn-ignore="true">{langView(lang)}</span>
                      ) : (
                        <span wovn-ignore="true">JP</span>
                      )}
                      <ul className="wovn-languages">
                        <li>
                          <button
                            type="button"
                            className="wovn-switch"
                            data-value="ja"
                            onClick={(e) => changelang(e)}
                          >
                            日本語
                          </button>
                        </li>
                        <li>
                          <button
                            type="button"
                            className="wovn-switch"
                            data-value="en"
                            onClick={(e) => changelang(e)}
                          >
                            English
                          </button>
                        </li>
                        <li>
                          <button
                            type="button"
                            className="wovn-switch"
                            data-value="ko"
                            onClick={(e) => changelang(e)}
                          >
                            한국어
                          </button>
                        </li>
                        <li>
                          <button
                            type="button"
                            className="wovn-switch"
                            data-value="zh-CHS"
                            onClick={(e) => changelang(e)}
                          >
                            简体中文
                          </button>
                        </li>
                        <li>
                          <button
                            type="button"
                            className="wovn-switch"
                            data-value="zh-CHT"
                            onClick={(e) => changelang(e)}
                          >
                            繁體中文
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                {/* <div className='floorGuide-wrap-pc'> */}
                <ul className="floorGuide-wrap pc">
                  <li className="floorGuide pink">
                    <p>
                      <span>遊ぶ</span>
                    </p>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="9"
                      height="7"
                      viewBox="0 0 18.438 14.47"
                      className="icon-anker"
                    >
                      <path
                        id="anker-arrow.svg"
                        className="cls-1"
                        d="M402.711,2438.44v-6.12a0.713,0.713,0,0,0-1.152-.57l-7.628,6.15a0.7,0.7,0,0,1-.883,0l-7.606-6.13a0.715,0.715,0,0,0-1.154.57v6.13a0.739,0.739,0,0,0,.271.57l8.489,6.83a0.7,0.7,0,0,0,.883,0l8.51-6.86a0.709,0.709,0,0,0,.27-0.57"
                        transform="translate(-384.281 -2431.59)"
                      />
                    </svg>
                    <div className="drop-nav">
                      <ul>
                        {PLAY_LINKS.map((headerLink) => (
                          <li
                            key={headerLink.link}
                            className={headerLink.under && 'under'}
                          >
                            {/* topページならばスムーススクロール */}
                            {headerLink.ankerFlg && topPageCheck() ? (
                              <Link
                                to={headerLink.link}
                                onClick={(e) =>
                                  scrollToTarget(e, headerLink.onClickLink)
                                }
                                onKeyDown={(e) =>
                                  scrollToTarget(e, modalLink.onClickLink)
                                }
                              >
                                <span>{headerLink.pageName}</span>
                              </Link>
                            ) : (
                              <Link to={headerLink.link}>
                                <span>{headerLink.pageName}</span>
                              </Link>
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </li>
                  <li className="floorGuide blue">
                    <p>
                      <span>観る</span>
                    </p>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="9"
                      height="7"
                      viewBox="0 0 18.438 14.47"
                      className="icon-anker"
                    >
                      <path
                        id="anker-arrow.svg"
                        className="cls-1"
                        d="M402.711,2438.44v-6.12a0.713,0.713,0,0,0-1.152-.57l-7.628,6.15a0.7,0.7,0,0,1-.883,0l-7.606-6.13a0.715,0.715,0,0,0-1.154.57v6.13a0.739,0.739,0,0,0,.271.57l8.489,6.83a0.7,0.7,0,0,0,.883,0l8.51-6.86a0.709,0.709,0,0,0,.27-0.57"
                        transform="translate(-384.281 -2431.59)"
                      />
                    </svg>
                    <div className="drop-nav">
                      <ul>
                        {WATCH_LINKS.map((headerLink) => (
                          <li
                            key={headerLink.link}
                            className={headerLink.under && 'under'}
                          >
                            {/* topページならばスムーススクロール */}
                            {headerLink.ankerFlg && topPageCheck() ? (
                              <Link
                                to={headerLink.link}
                                onClick={(e) =>
                                  scrollToTarget(e, headerLink.onClickLink)
                                }
                                onKeyDown={(e) =>
                                  scrollToTarget(e, modalLink.onClickLink)
                                }
                              >
                                <span>{headerLink.pageName}</span>
                              </Link>
                            ) : (
                              <Link to={headerLink.link}>
                                <span>{headerLink.pageName}</span>
                              </Link>
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </li>
                  <li className="floorGuide orange">
                    <p>
                      <span>食べる</span>
                    </p>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="9"
                      height="7"
                      viewBox="0 0 18.438 14.47"
                      className="icon-anker"
                    >
                      <path
                        id="anker-arrow.svg"
                        className="cls-1"
                        d="M402.711,2438.44v-6.12a0.713,0.713,0,0,0-1.152-.57l-7.628,6.15a0.7,0.7,0,0,1-.883,0l-7.606-6.13a0.715,0.715,0,0,0-1.154.57v6.13a0.739,0.739,0,0,0,.271.57l8.489,6.83a0.7,0.7,0,0,0,.883,0l8.51-6.86a0.709,0.709,0,0,0,.27-0.57"
                        transform="translate(-384.281 -2431.59)"
                      />
                    </svg>
                    <div className="drop-nav">
                      <ul>
                        {EAT_LINKS.map((headerLink) => (
                          <li
                            key={headerLink.link}
                            className={headerLink.under && 'under'}
                          >
                            {/* topページならばスムーススクロール */}
                            {headerLink.ankerFlg && topPageCheck() ? (
                              <Link
                                to={headerLink.link}
                                onClick={(e) =>
                                  scrollToTarget(e, headerLink.onClickLink)
                                }
                                onKeyDown={(e) =>
                                  scrollToTarget(e, modalLink.onClickLink)
                                }
                              >
                                <span>{headerLink.pageName}</span>
                              </Link>
                            ) : (
                              <Link to={headerLink.link}>
                                <span>{headerLink.pageName}</span>
                              </Link>
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </li>
                  {eventHallShow === '1' && (
                    <li className="floorGuide green">
                      <p>
                        <span>イベント</span>
                      </p>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="9"
                        height="7"
                        viewBox="0 0 18.438 14.47"
                        className="icon-anker"
                      >
                        <path
                          id="anker-arrow.svg"
                          className="cls-1"
                          d="M402.711,2438.44v-6.12a0.713,0.713,0,0,0-1.152-.57l-7.628,6.15a0.7,0.7,0,0,1-.883,0l-7.606-6.13a0.715,0.715,0,0,0-1.154.57v6.13a0.739,0.739,0,0,0,.271.57l8.489,6.83a0.7,0.7,0,0,0,.883,0l8.51-6.86a0.709,0.709,0,0,0,.27-0.57"
                          transform="translate(-384.281 -2431.59)"
                        />
                      </svg>
                      <div className="drop-nav">
                        <ul>
                          {EVENT_LINKS.map((headerLink) => (
                            <li
                              key={headerLink.link}
                              className={headerLink.under && 'under'}
                            >
                              {headerLink.target ? (
                                <a
                                  href={headerLink.link}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <span>{headerLink.pageName}</span>
                                </a>
                              ) : (
                                <Link to={headerLink.link}>
                                  <span>{headerLink.pageName}</span>
                                </Link>
                              )}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </li>
                  )}
                </ul>
                <nav>
                  <ul className="header-menu">
                    {HEADER_LINKS.map((headerLink) => (
                      <li key={headerLink.link}>
                        <Link
                          to={headerLink.link}
                          className={headerLink.classes}
                        >
                          <span>{headerLink.pageName}</span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                  <Link to="/access/" className="sp-header-icon sp">
                    <Image src="icon-header-access.svg" />
                    <span>アクセス</span>
                  </Link>
                  <Link to="/schedule/" className="sp-header-icon sp">
                    <Image src="icon-header-schedule.svg" />
                    <span>営業時間</span>
                  </Link>
                  <button
                    type="button"
                    className="hbg sp"
                    id="js-hbg"
                    onClick={props.hbgClick}
                    onKeyDown={props.hbgClick}
                  >
                    <div className="wrap">
                      <span />
                      <span />
                      <span />
                      <span className="en" wovn-ignore="true">
                        <b className="menu">
                          <b>M</b>
                          <b>E</b>
                          <b>N</b>
                          <b>U</b>
                        </b>
                        <b className="close">
                          <b>C</b>
                          <b>L</b>
                          <b>O</b>
                          <b>S</b>
                          <b>E</b>
                        </b>
                      </span>
                    </div>
                  </button>
                </nav>
              </div>
              {/* </div> */}
              {/* <div className='event-anker-link-wrap sp'>
                {topPageCheck() ? (
                  <>
                    <Link to="#play" className="play" onClick={(e) => scrollToTarget(e, "play")} onKeyDown={(e) => scrollToTarget(e, "play")}>
                      <span>遊ぶ</span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="14" viewBox="0 0 18.438 14.47" className='icon-anker'>
                        <path id="anker-arrow.svg" className="cls-1" d="M402.711,2438.44v-6.12a0.713,0.713,0,0,0-1.152-.57l-7.628,6.15a0.7,0.7,0,0,1-.883,0l-7.606-6.13a0.715,0.715,0,0,0-1.154.57v6.13a0.739,0.739,0,0,0,.271.57l8.489,6.83a0.7,0.7,0,0,0,.883,0l8.51-6.86a0.709,0.709,0,0,0,.27-0.57" transform="translate(-384.281 -2431.59)"/>
                      </svg>
                    </Link>
                    <Link to="#watch" className="watch" onClick={(e) => scrollToTarget(e, "watch")} onKeyDown={(e) => scrollToTarget(e, "watch")}>
                      <span>観る</span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="14" viewBox="0 0 18.438 14.47" className='icon-anker'>
                        <path id="anker-arrow.svg" className="cls-1" d="M402.711,2438.44v-6.12a0.713,0.713,0,0,0-1.152-.57l-7.628,6.15a0.7,0.7,0,0,1-.883,0l-7.606-6.13a0.715,0.715,0,0,0-1.154.57v6.13a0.739,0.739,0,0,0,.271.57l8.489,6.83a0.7,0.7,0,0,0,.883,0l8.51-6.86a0.709,0.709,0,0,0,.27-0.57" transform="translate(-384.281 -2431.59)"/>
                      </svg>
                    </Link>
                    <Link to="#eat" className="eat" onClick={(e) => scrollToTarget(e, "eat")} onKeyDown={(e) => scrollToTarget(e, "eat")}>
                      <span>食べる</span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="14" viewBox="0 0 18.438 14.47" className='icon-anker'>
                        <path id="anker-arrow.svg" className="cls-1" d="M402.711,2438.44v-6.12a0.713,0.713,0,0,0-1.152-.57l-7.628,6.15a0.7,0.7,0,0,1-.883,0l-7.606-6.13a0.715,0.715,0,0,0-1.154.57v6.13a0.739,0.739,0,0,0,.271.57l8.489,6.83a0.7,0.7,0,0,0,.883,0l8.51-6.86a0.709,0.709,0,0,0,.27-0.57" transform="translate(-384.281 -2431.59)"/>
                      </svg>
                    </Link>
                    {eventHallShow === '1' && (
                      <Link to="#event-hall" className="event-hall" onClick={(e) => scrollToTarget(e, "event-hall")} onKeyDown={(e) => scrollToTarget(e, "event-hall")}>
                        <span>イベント</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="14" viewBox="0 0 18.438 14.47" className='icon-anker'>
                          <path id="anker-arrow.svg" className="cls-1" d="M402.711,2438.44v-6.12a0.713,0.713,0,0,0-1.152-.57l-7.628,6.15a0.7,0.7,0,0,1-.883,0l-7.606-6.13a0.715,0.715,0,0,0-1.154.57v6.13a0.739,0.739,0,0,0,.271.57l8.489,6.83a0.7,0.7,0,0,0,.883,0l8.51-6.86a0.709,0.709,0,0,0,.27-0.57" transform="translate(-384.281 -2431.59)"/>
                        </svg>
                      </Link>
                    )}
                  </>
                ):(
                  <>
                    <Link to="/?play" className="play" >
                      <span>遊ぶ</span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="14" viewBox="0 0 18.438 14.47" className='icon-anker'>
                        <path id="anker-arrow.svg" className="cls-1" d="M402.711,2438.44v-6.12a0.713,0.713,0,0,0-1.152-.57l-7.628,6.15a0.7,0.7,0,0,1-.883,0l-7.606-6.13a0.715,0.715,0,0,0-1.154.57v6.13a0.739,0.739,0,0,0,.271.57l8.489,6.83a0.7,0.7,0,0,0,.883,0l8.51-6.86a0.709,0.709,0,0,0,.27-0.57" transform="translate(-384.281 -2431.59)"/>
                      </svg>
                    </Link>
                    <Link to="/?watch" className="watch" >
                      <span>観る</span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="14" viewBox="0 0 18.438 14.47" className='icon-anker'>
                        <path id="anker-arrow.svg" className="cls-1" d="M402.711,2438.44v-6.12a0.713,0.713,0,0,0-1.152-.57l-7.628,6.15a0.7,0.7,0,0,1-.883,0l-7.606-6.13a0.715,0.715,0,0,0-1.154.57v6.13a0.739,0.739,0,0,0,.271.57l8.489,6.83a0.7,0.7,0,0,0,.883,0l8.51-6.86a0.709,0.709,0,0,0,.27-0.57" transform="translate(-384.281 -2431.59)"/>
                      </svg>
                    </Link>
                    <Link to="/?eat" className="eat" >
                      <span>食べる</span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="14" viewBox="0 0 18.438 14.47" className='icon-anker'>
                        <path id="anker-arrow.svg" className="cls-1" d="M402.711,2438.44v-6.12a0.713,0.713,0,0,0-1.152-.57l-7.628,6.15a0.7,0.7,0,0,1-.883,0l-7.606-6.13a0.715,0.715,0,0,0-1.154.57v6.13a0.739,0.739,0,0,0,.271.57l8.489,6.83a0.7,0.7,0,0,0,.883,0l8.51-6.86a0.709,0.709,0,0,0,.27-0.57" transform="translate(-384.281 -2431.59)"/>
                      </svg>
                    </Link>
                    {eventHallShow === '1' && (
                      <Link to="/?event-hall" className="event-hall" >
                        <span>イベント</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="14" viewBox="0 0 18.438 14.47" className='icon-anker'>
                          <path id="anker-arrow.svg" className="cls-1" d="M402.711,2438.44v-6.12a0.713,0.713,0,0,0-1.152-.57l-7.628,6.15a0.7,0.7,0,0,1-.883,0l-7.606-6.13a0.715,0.715,0,0,0-1.154.57v6.13a0.739,0.739,0,0,0,.271.57l8.489,6.83a0.7,0.7,0,0,0,.883,0l8.51-6.86a0.709,0.709,0,0,0,.27-0.57" transform="translate(-384.281 -2431.59)"/>
                        </svg>
                      </Link>
                    )}
                  </>
                )}
              </div> */}
              <div className="event-anker-link-wrap-dropDown sp">
                {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                <div
                  className={`floorGuideDropDown pink ${isDropDownTab === 'pink' ? 'click' : ''
                    }`}
                  onClick={() => onClickDropDown('pink')}
                >
                  <p>
                    <span>遊ぶ</span>
                  </p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="9"
                    height="7"
                    viewBox="0 0 18.438 14.47"
                    className="icon-anker"
                  >
                    <path
                      id="anker-arrow.svg"
                      className="cls-1"
                      d="M402.711,2438.44v-6.12a0.713,0.713,0,0,0-1.152-.57l-7.628,6.15a0.7,0.7,0,0,1-.883,0l-7.606-6.13a0.715,0.715,0,0,0-1.154.57v6.13a0.739,0.739,0,0,0,.271.57l8.489,6.83a0.7,0.7,0,0,0,.883,0l8.51-6.86a0.709,0.709,0,0,0,.27-0.57"
                      transform="translate(-384.281 -2431.59)"
                    />
                  </svg>
                  <div
                    className={`drop-nav ${isDropDownTab === 'pink' ? 'show' : ''
                      }`}
                  >
                    <ul>
                      {PLAY_LINKS.map((headerLink) => (
                        <li
                          key={headerLink.link}
                          className={headerLink.under && 'under'}
                        >
                          {/* topページならばスムーススクロール */}
                          {headerLink.ankerFlg && topPageCheck() ? (
                            <Link
                              to={headerLink.link}
                              onClick={(e) =>
                                scrollToTarget(e, headerLink.onClickLink)
                              }
                              onKeyDown={(e) =>
                                scrollToTarget(e, modalLink.onClickLink)
                              }
                            >
                              <span>{headerLink.pageName}</span>
                            </Link>
                          ) : (
                            <Link to={headerLink.link}>
                              <span>{headerLink.pageName}</span>
                            </Link>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                <div
                  className={`floorGuideDropDown blue ${isDropDownTab === 'blue' ? 'click' : ''
                    }`}
                  onClick={() => onClickDropDown('blue')}
                >
                  <p>
                    <span>観る</span>
                  </p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="9"
                    height="7"
                    viewBox="0 0 18.438 14.47"
                    className="icon-anker"
                  >
                    <path
                      id="anker-arrow.svg"
                      className="cls-1"
                      d="M402.711,2438.44v-6.12a0.713,0.713,0,0,0-1.152-.57l-7.628,6.15a0.7,0.7,0,0,1-.883,0l-7.606-6.13a0.715,0.715,0,0,0-1.154.57v6.13a0.739,0.739,0,0,0,.271.57l8.489,6.83a0.7,0.7,0,0,0,.883,0l8.51-6.86a0.709,0.709,0,0,0,.27-0.57"
                      transform="translate(-384.281 -2431.59)"
                    />
                  </svg>
                  <div
                    className={`drop-nav ${isDropDownTab === 'blue' ? 'show' : ''
                      }`}
                  >
                    <ul>
                      {WATCH_LINKS.map((headerLink) => (
                        <li
                          key={headerLink.link}
                          className={headerLink.under && 'under'}
                        >
                          {/* topページならばスムーススクロール */}
                          {headerLink.ankerFlg && topPageCheck() ? (
                            <Link
                              to={headerLink.link}
                              onClick={(e) =>
                                scrollToTarget(e, headerLink.onClickLink)
                              }
                              onKeyDown={(e) =>
                                scrollToTarget(e, modalLink.onClickLink)
                              }
                            >
                              <span>{headerLink.pageName}</span>
                            </Link>
                          ) : (
                            <Link to={headerLink.link}>
                              <span>{headerLink.pageName}</span>
                            </Link>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                <div
                  className={`floorGuideDropDown orange ${isDropDownTab === 'orange' ? 'click' : ''
                    }`}
                  onClick={() => onClickDropDown('orange')}
                >
                  <p>
                    <span>食べる</span>
                  </p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="9"
                    height="7"
                    viewBox="0 0 18.438 14.47"
                    className="icon-anker"
                  >
                    <path
                      id="anker-arrow.svg"
                      className="cls-1"
                      d="M402.711,2438.44v-6.12a0.713,0.713,0,0,0-1.152-.57l-7.628,6.15a0.7,0.7,0,0,1-.883,0l-7.606-6.13a0.715,0.715,0,0,0-1.154.57v6.13a0.739,0.739,0,0,0,.271.57l8.489,6.83a0.7,0.7,0,0,0,.883,0l8.51-6.86a0.709,0.709,0,0,0,.27-0.57"
                      transform="translate(-384.281 -2431.59)"
                    />
                  </svg>
                  <div
                    className={`drop-nav ${isDropDownTab === 'orange' ? 'show' : ''
                      }`}
                  >
                    <ul>
                      {EAT_LINKS.map((headerLink) => (
                        <li
                          key={headerLink.link}
                          className={headerLink.under && 'under'}
                        >
                          {/* topページならばスムーススクロール */}
                          {headerLink.ankerFlg && topPageCheck() ? (
                            <Link
                              to={headerLink.link}
                              onClick={(e) =>
                                scrollToTarget(e, headerLink.onClickLink)
                              }
                              onKeyDown={(e) =>
                                scrollToTarget(e, modalLink.onClickLink)
                              }
                            >
                              <span>{headerLink.pageName}</span>
                            </Link>
                          ) : (
                            <Link to={headerLink.link}>
                              <span>{headerLink.pageName}</span>
                            </Link>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                {eventHallShow === '1' && (
                  // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
                  <div
                    className={`floorGuideDropDown green ${isDropDownTab === 'green' ? 'click' : ''
                      }`}
                    onClick={() => onClickDropDown('green')}
                  >
                    <p>
                      <span>イベント</span>
                    </p>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="9"
                      height="7"
                      viewBox="0 0 18.438 14.47"
                      className="icon-anker"
                    >
                      <path
                        id="anker-arrow.svg"
                        className="cls-1"
                        d="M402.711,2438.44v-6.12a0.713,0.713,0,0,0-1.152-.57l-7.628,6.15a0.7,0.7,0,0,1-.883,0l-7.606-6.13a0.715,0.715,0,0,0-1.154.57v6.13a0.739,0.739,0,0,0,.271.57l8.489,6.83a0.7,0.7,0,0,0,.883,0l8.51-6.86a0.709,0.709,0,0,0,.27-0.57"
                        transform="translate(-384.281 -2431.59)"
                      />
                    </svg>
                    <div
                      className={`drop-nav ${isDropDownTab === 'green' ? 'show' : ''
                        }`}
                    >
                      <ul>
                        {EVENT_LINKS.map((headerLink) => (
                          <li
                            key={headerLink.link}
                            className={headerLink.under && 'under'}
                          >
                            {headerLink.target ? (
                              <a
                                href={headerLink.link}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <span>{headerLink.pageName}</span>
                              </a>
                            ) : (
                              <Link to={headerLink.link}>
                                <span>{headerLink.pageName}</span>
                              </Link>
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </header>
            <div className="slide-nav">
              <div className="sp-slide-nav">
                <div className="btn-wrap single flex-btns-slide">
                  <Button href="/ticket/how/" className="btn-buy-black">
                    チケット・料金
                  </Button>
                </div>
              </div>
              <ul className="modal-menu">
                <li>
                  <ul className="header-nav-top-link">
                    <li>
                      <Link to="/information/" className="fwb">
                        施設案内
                      </Link>
                    </li>
                    <li>
                      <a href="/inquiry/chat/">お問合わせ</a>
                    </li>
                  </ul>
                </li>
                <li>
                  <ul className="sns">
                    <li className="cn-hide">
                      <a
                        href="https://twitter.com/EZOFUKUOKA"
                        className="tw fwb"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Image
                          src="icon-tw.png"
                          alt="twitter"
                          target="_blank"
                          width="20px"
                          height="20px"
                        />
                      </a>
                    </li>
                    <li className="cn-hide">
                      <a
                        href="https://www.instagram.com/ezofukuoka/"
                        className="ig fwb"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Image
                          src="ig.svg"
                          alt="instagram"
                          target="_blank"
                          width="26px"
                          height="28px"
                        />
                      </a>
                    </li>
                    <li className="cn-hide">
                      <a
                        href="https://www.youtube.com/channel/UCf_4SX2KMdo1ieafAj2vwLw"
                        className="yt fwb"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Image
                          src="icon-youtube.svg"
                          alt="youtube"
                          target="_blank"
                          width="26px"
                          height="26px"
                        />
                      </a>
                    </li>
                  </ul>
                </li>
                <li>
                  <AccordionMin title="遊ぶ">
                    {PLAY_LINKS.map((spPlay) => (
                      <li key={spPlay.link} className={spPlay.under && 'under'}>
                        {/* topページならばスムーススクロール */}
                        {spPlay.ankerFlg && topPageCheck() && (
                          <Link
                            to={spPlay.link}
                            className={`${spPlay.bold ? 'fwb' : ''} ${!spPlay.link ? 'disable' : ''
                              }`}
                            onClick={(e) =>
                              scrollToTarget(e, spPlay.onClickLink)
                            }
                            onKeyDown={(e) =>
                              scrollToTarget(e, spPlay.onClickLink)
                            }
                          >
                            {spPlay.pageName}
                            {spPlay.link ? (
                              <Image src="breadcrumb-arrow.svg" />
                            ) : null}
                          </Link>
                        )}
                        {spPlay.targetBlank ? (
                          <a
                            href={spPlay.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`${spPlay.bold ? 'fwb' : ''} ${!spPlay.link ? 'disable' : ''
                              }`}
                          >
                            {spPlay.pageName}
                            {spPlay.link ? (
                              <Image src="breadcrumb-arrow.svg" />
                            ) : null}
                          </a>
                        ) : (
                          <Link
                            to={spPlay.link}
                            className={`${spPlay.bold ? 'fwb' : ''} ${!spPlay.link ? 'disable' : ''
                              }`}
                          >
                            {spPlay.pageName}
                            {spPlay.link ? (
                              <Image src="breadcrumb-arrow.svg" />
                            ) : null}
                          </Link>
                        )}
                      </li>
                    ))}
                  </AccordionMin>
                </li>
                <li>
                  <AccordionMin title="観る">
                    {WATCH_LINKS.map((spWatch) => (
                      <li
                        key={spWatch.link}
                        className={spWatch.under && 'under'}
                      >
                        {/* topページならばスムーススクロール */}
                        {spWatch.ankerFlg && topPageCheck() && (
                          <Link
                            to={spWatch.link}
                            className={`${spWatch.bold ? 'fwb' : ''} ${!spWatch.link ? 'disable' : ''
                              }`}
                            onClick={(e) =>
                              scrollToTarget(e, spWatch.onClickLink)
                            }
                            onKeyDown={(e) =>
                              scrollToTarget(e, spWatch.onClickLink)
                            }
                          >
                            {spWatch.pageName}
                            {spWatch.link ? (
                              <Image src="breadcrumb-arrow.svg" />
                            ) : null}
                          </Link>
                        )}
                        {spWatch.targetBlank ? (
                          <a
                            href={spWatch.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`${spWatch.bold ? 'fwb' : ''} ${!spWatch.link ? 'disable' : ''
                              }`}
                          >
                            {spWatch.pageName}
                            {spWatch.link ? (
                              <Image src="breadcrumb-arrow.svg" />
                            ) : null}
                          </a>
                        ) : (
                          <Link
                            to={spWatch.link}
                            className={`${spWatch.bold ? 'fwb' : ''} ${!spWatch.link ? 'disable' : ''
                              }`}
                          >
                            {spWatch.pageName}
                            {spWatch.link ? (
                              <Image src="breadcrumb-arrow.svg" />
                            ) : null}
                          </Link>
                        )}
                      </li>
                    ))}
                  </AccordionMin>
                </li>
                <li>
                  <AccordionMin title="食べる">
                    {EAT_LINKS.map((spEat) => (
                      <li key={spEat.link} className={spEat.under && 'under'}>
                        {/* topページならばスムーススクロール */}
                        {spEat.ankerFlg && topPageCheck() && (
                          <Link
                            to={spEat.link}
                            className={`${spEat.bold ? 'fwb' : ''} ${!spEat.link ? 'disable' : ''
                              }`}
                            onClick={(e) =>
                              scrollToTarget(e, spEat.onClickLink)
                            }
                            onKeyDown={(e) =>
                              scrollToTarget(e, spEat.onClickLink)
                            }
                          >
                            {spEat.pageName}
                            {spEat.link ? (
                              <Image src="breadcrumb-arrow.svg" />
                            ) : null}
                          </Link>
                        )}
                        {spEat.targetBlank ? (
                          <a
                            href={spEat.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`${spEat.bold ? 'fwb' : ''} ${!spEat.link ? 'disable' : ''
                              }`}
                          >
                            {spEat.pageName}
                            {spEat.link ? (
                              <Image src="breadcrumb-arrow.svg" />
                            ) : null}
                          </a>
                        ) : (
                          <Link
                            to={spEat.link}
                            className={`${spEat.bold ? 'fwb' : ''} ${!spEat.link ? 'disable' : ''
                              }`}
                          >
                            {spEat.pageName}
                            {spEat.link ? (
                              <Image src="breadcrumb-arrow.svg" />
                            ) : null}
                          </Link>
                        )}
                      </li>
                    ))}
                  </AccordionMin>
                </li>
                {eventHallShow === '1' && (
                  <li>
                    <AccordionMin title="イベント">
                      {EVENT_LINKS.map((spEat) => (
                        <li key={spEat.link} className={spEat.under && 'under'}>
                          {/* topページならばスムーススクロール */}
                          {spEat.ankerFlg && topPageCheck() && (
                            <Link
                              to={spEat.link}
                              className={`${spEat.bold ? 'fwb' : ''} ${!spEat.link ? 'disable' : ''
                                }`}
                              onClick={(e) =>
                                scrollToTarget(e, spEat.onClickLink)
                              }
                              onKeyDown={(e) =>
                                scrollToTarget(e, spEat.onClickLink)
                              }
                            >
                              {spEat.pageName}
                              {spEat.link ? (
                                <Image src="breadcrumb-arrow.svg" />
                              ) : null}
                            </Link>
                          )}
                          {spEat.targetBlank ? (
                            <a
                              href={spEat.link}
                              target="_blank"
                              rel="noopener noreferrer"
                              className={`${spEat.bold ? 'fwb' : ''} ${!spEat.link ? 'disable' : ''
                                }`}
                            >
                              {spEat.pageName}
                              {spEat.link ? (
                                <Image src="breadcrumb-arrow.svg" />
                              ) : null}
                            </a>
                          ) : (
                            <Link
                              to={spEat.link}
                              className={`${spEat.bold ? 'fwb' : ''} ${!spEat.link ? 'disable' : ''
                                }`}
                            >
                              {spEat.pageName}
                              {spEat.link ? (
                                <Image src="breadcrumb-arrow.svg" />
                              ) : null}
                            </Link>
                          )}
                        </li>
                      ))}
                    </AccordionMin>
                  </li>
                )}
                {HBG_LINK.map((hbgLink) => (
                  <li key={hbgLink.link}>
                    {/* topページならばスムーススクロール */}
                    {hbgLink.ankerFlg && topPageCheck() && (
                      <Link
                        to={hbgLink.link}
                        className={`${hbgLink.bold ? 'fwb' : ''} ${!hbgLink.link ? 'disable' : ''
                          }`}
                        onClick={(e) => scrollToTarget(e, hbgLink.onClickLink)}
                        onKeyDown={(e) =>
                          scrollToTarget(e, hbgLink.onClickLink)
                        }
                      >
                        {hbgLink.pageName}
                        {hbgLink.link ? (
                          <Image src="breadcrumb-arrow.svg" />
                        ) : null}
                      </Link>
                    )}
                    {hbgLink.targetBlank ? (
                      <a
                        href={hbgLink.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`${hbgLink.bold ? 'fwb' : ''} ${!hbgLink.link ? 'disable' : ''
                          }`}
                      >
                        {hbgLink.pageName}
                        {hbgLink.link ? (
                          <Image src="breadcrumb-arrow.svg" />
                        ) : null}
                      </a>
                    ) : (
                      <Link
                        to={hbgLink.link}
                        className={`${hbgLink.bold ? 'fwb' : ''} ${!hbgLink.link ? 'disable' : ''
                          }`}
                      >
                        {hbgLink.pageName}
                        {hbgLink.link ? (
                          <Image src="breadcrumb-arrow.svg" />
                        ) : null}
                      </Link>
                    )}
                  </li>
                ))}
                <div className="btn-wrap single flex-btns-slide flex-btns-slide-bottom">
                  <Button
                    href="/zekkei-brothers/"
                    className="btn-regular btn-zekkei"
                  >
                    絶景3兄弟 SMBC日興証券
                    <br />
                    運行状況
                  </Button>
                </div>
                <div className="sp-lang" wovn-ignore="true">
                  <select
                    name=""
                    id=""
                    value={lang}
                    onChange={(e) => changelangSp(e)}
                  >
                    <option value="ja">日本語</option>
                    <option value="en">English</option>
                    <option value="ko">한국어</option>
                    <option value="zh-CHS">简体中文</option>
                    <option value="zh-CHT">繁體中文</option>
                  </select>
                </div>
              </ul>
            </div>
          </>
        );
      }}
    />
  );
};

export default Header;
